/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DailyInvite.vue?vue&type=template&id=520b129a&scoped=true"
import script from "./DailyInvite.vue?vue&type=script&lang=js"
export * from "./DailyInvite.vue?vue&type=script&lang=js"
import style0 from "./DailyInvite.vue?vue&type=style&index=0&id=520b129a&prod&lang=scss"
import style1 from "./DailyInvite.vue?vue&type=style&index=1&id=520b129a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b129a",
  null
  
)

export default component.exports